import {debounce} from "lodash";
import {Typography} from "antd";
import {Trans} from "react-i18next";
import React from "react";
import {BiodiversityInput} from "../../../assets/AssetsTable/filters/BiodiversityDistance";
import {AssetsFiltersFE, StaticAssetsFilters} from "../../../../types/internal/tables/assetsTable";

interface BiodiversityDistanceProps {
  filters: AssetsFiltersFE
  addFilters: (addFilters: AssetsFiltersFE) => void,
  removeFilters: (removeFilters: ((StaticAssetsFilters | 'hazards') | string)[] | ((StaticAssetsFilters | 'hazards') | string)) => void,
}
export default function BiodiversityDistanceCreationAreas({
  filters,
  addFilters,
  removeFilters,
}: BiodiversityDistanceProps) {
  const distance = filters.biodiversity_distance === undefined ? "0" : filters.biodiversity_distance
  const debounceUpdate = debounce((v: number | undefined) => {
    if (typeof v === 'number' && v >= 0) {
      addFilters({biodiversity_distance: v});
    } else {
      removeFilters('biodiversity_distance');
    }
  }, 500);

  return <div
    style={{marginBottom: '1rem'}}>
    <div
      style={{marginBottom: '0.5rem'}}>
      <Trans i18nKey={'assets.biodiversityDistanceInsert'}
             components={{p: <Typography.Paragraph italic style={{margin: 0}}/>}}/>
    </div>
    <BiodiversityInput
      value={distance}
      onValueChange={value => {
        debounceUpdate(value.floatValue);
      }}
    />
  </div>
}
